import { Paper } from '@mui/material';
import { useDomain } from '../../../../../../states/AppDomainProvider';
import { getActivityCardThumbnailByActivityType } from '../../../../../../utils/activitytype/ActivityTypesUtil';
import './LessonPagesList.scss';

function LessonPagesList({
  selectedPageIndexes,
  onSelectePage,
} = {
  selectedPageIndexes: [],
  onSelectePage: () => null,
}) {
  const { lessonDataMaintenanceDomain } = useDomain();
  const { pagesData } = lessonDataMaintenanceDomain.domainData;
  const cards = getActivityCardThumbnailByActivityType(pagesData);

  const handleOnTogglePageSelection = (isSelected, index) => {
    if (isSelected) {
      const updatedSelectedPage = selectedPageIndexes.filter((s) => s !== index);
      onSelectePage(updatedSelectedPage);
    } else {
      const updatedSelectedPage = [...selectedPageIndexes, index];
      onSelectePage(updatedSelectedPage);
    }
  };

  const handleOnMoveFocus = (event, index) => {
    if (event.key !== 'Tab') {
      return;
    }

    const pageCards = Array.from(document.querySelectorAll('.lesson-pages-list .lesson-page-card'));
    if (pageCards.length === 0) {
      return;
    }

    const step = event.shiftKey ? -1 : 1;
    const nextIndex = index + step;

    if (nextIndex < 0 || nextIndex >= pageCards.length) {
      return;
    }

    event.preventDefault();
    pageCards[nextIndex]?.focus();
  };

  return (
    <div className='lesson-pages-list'>
      {cards.map((card, index) => {
        const isSelected = selectedPageIndexes.includes(index);
        return (
          <Paper
            className={`lesson-page-card ${isSelected ? 'vizzle-selected-component' : ''}`}
            key={`lesson-pages-selection-page-${index}`}
            onClick={() => {
              handleOnTogglePageSelection(isSelected, index);
            }}
            tabIndex={0}
            onKeyDown={(e) => {
              handleOnMoveFocus(e, index);

              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleOnTogglePageSelection(isSelected, index);
              }
            }}
          >
            {card}
          </Paper>
        );
      })}
    </div>
  );
}

export default LessonPagesList;
